import React, { useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import {
  Button,
  makeStyles,
  TableFooter,
  TableCell,
  TableRow,
  CircularProgress,
} from "@material-ui/core";
import { Pagination } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import {
  DropdownCustomToggler,
  DropdownMenu4,
} from "../../_metronic/_partials/dropdowns";
import { ProgressBar, Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import Moment from "moment";
import {
  getLicenseReqList,
  getDetailContact,
  deleteReqHistory,
  updateContact,
} from "../modules/api";
import MUIDataTable from "mui-datatables";

export function LicenseReqMng() {
  const [isShow, setIsShow] = useState(false);
  const [licenseReqList, setLicenseReqList] = useState([]);
  const [licenseReqDetail, setLicenseReqDetail] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [companyName, setCompanyName] = useState();
  const [selectReqList, setSelectReqList] = useState();
  const [contactNo, setContactNo] = useState();

  const [input, setInput] = useState({
    companyName: "",
    department: "",
    phone: "",
    email: "",
    userType: "",
    reqType: "",
    licenseNumber: "",
    status: "",
    contents: "",
    procContents: "",
    contactNo: "",
  });

  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
    centeredHeader: {
      "& span": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 15,
        fontWeight: "bold",
      },
    },
  }));

  const classes = useStyles();

  const fetchData = async () => {
    try {
      const result = await getLicenseReqList();
      console.log("getLicenseReqList", result);

      let list = [];
      result.data.map((data, index) => {
        if (data.deletedAt === null) {
          // if (data.user) {
          var obj = new Object();
          obj.idx = index;
          obj.no = data.no;
          obj.companyName = data.user
            ? data.user.companyName
            : data.companyName;
          obj.department = data.user ? data.user.department : data.department;
          obj.phone = data.user ? data.user.phone : data.phone;
          obj.email = data.user ? data.user.loginId : data.email;
          obj.userType = data.user === null ? "비회원" : "회원";
          obj.reqType = data.type;
          obj.status = data.status;
          obj.contents = data.contents;
          obj.procContents = data.answer;
          obj.licenseNumber =
            data.licenseHistory !== null
              ? data.licenseHistory.licenseNumber
              : "";
          obj.createdAt = data.createdAt
            ? Moment(data.createdAt).format("YYYY-MM-DD HH:mm:ss")
            : "-";
          obj.updatedAt = data.updatedAt
            ? Moment(data.updatedAt).format("YYYY-MM-DD HH:mm:ss")
            : "-";

          list.push(obj);
          // }
        }
      });

      setLicenseReqList(list);
    } catch (e) {
      console.log(e);
      // Handle error
    }
  };

  useEffect(() => {
    setListLoading(true);
    setTimeout(async () => {
      fetchData();
      setListLoading(false);
    }, 1000);
  }, []);

  const detailReq = async (value) => {
    const res = await getDetailContact(value);
    console.log("getDetailContact", res);
    setLicenseReqDetail(res.data);
    toggleShow();
  };

  const columns = [
    {
      name: "no",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "companyName",
      label: "고객사명",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "department",
      label: "부서",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "phone",
      label: "연락처",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "email",
      label: "LoginId",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "userType",
      label: "회원분류",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "reqType",
      label: "문의분류",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
        customBodyRender: (value, meta) => {
          let textLabel;

          if (value === "new") {
            textLabel = "일반";
          } else if (value === "extend") {
            textLabel = "연장";
          }
          return (
            <div>
              <span>{textLabel}</span>
            </div>
          );
        },
      },
    },
    {
      name: "status",
      label: "상태",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
        customBodyRender: (value, meta) => {
          let textLabel;
          let textColor;

          if (value === "contact") {
            textLabel = "문의";
            textColor = "label-success";
          } else if (value === "review") {
            textLabel = "처리중";
            textColor = "label-primary";
          } else if (value === "finish") {
            textLabel = "완료";
            textColor = "label-secondary";
          }
          return (
            <div>
              <span className={"label label-xl label-inline " + textColor}>
                {textLabel}
              </span>
            </div>
          );
        },
      },
    },
    {
      name: "createdAt",
      label: "문의요청일시",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "updatedAt",
      label: "상태변경일시",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
        setCellHeaderProps: () => ({
          className: classes.centeredHeader,
        }),
      },
    },
    {
      name: "action",
      label: "상세",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center", fontSize: 15, fontWeight: "bold" },
        }),
        customBodyRender: (value, meta) => {
          console.log("meta", meta);
          // if (userNo.toString() === meta.rowData[6].toString()) {
          return (
            <div className="card-toolbar">
              <Button
                className={`btn font-weight-bolder font-size-sm mr-2`}
                style={{ background: "lightgray" }}
                onClick={() => {
                  setInput({
                    companyName: meta.rowData[1],
                    department: meta.rowData[2],
                    phone: meta.rowData[3],
                    email: meta.rowData[4],
                    userType: meta.rowData[5],
                    reqType: meta.rowData[6] === "new" ? "일반" : "연장",
                    licenseNumber: meta.rowData[11],
                    status: meta.rowData[7],
                    contents: meta.rowData[12],
                    procContents: meta.rowData[13],
                    contactNo: meta.rowData[0],
                  });
                  setIsShow(true);
                }}
              >
                보기
              </Button>
            </div>
          );
          // }
        },
      },
    },
    {
      name: "licenseNumber",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "contents",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "procContents",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      },
    },
  ];

  const options = {
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    rowsPerPage: 15,
    rowsPerPageOptions: [],
    selectToolbarPlacement: "none",
    selectableRows: true,
    onRowSelectionChange: (
      currentRowsSelected,
      allRowsSelected,
      rowsSelected
    ) => {
      let temp = [];
      let indexes = [];
      rowsSelected.forEach((row) => {
        indexes.push(row);
      });
      licenseReqList.map((data, index) => {
        if (indexes.includes(data.idx)) {
          temp.push(data.no);
        }
      });
      // console.log("indexes", indexes);
      // console.log("temp", temp.toString());
      setSelectReqList(temp.toString());
    },

    textLabels: {
      body: {
        noMatch: listLoading ? (
          <CircularProgress size={25} color={"inherit"} />
        ) : licenseReqList.length > 0 ? (
          ""
        ) : (
          "검색 결과가 없습니다."
        ),
      },
    },
  };

  const toggleShow = () => {
    setIsShow(!isShow);
  };

  const delReqHistory = async () => {
    if (selectReqList === undefined) {
      alert("1개 이상의 내역을 선택해 주세요.");
      return false;
    }

    if (window.confirm("라이선스 문의 내역을 삭제하시겠습니까?")) {
      const res = await deleteReqHistory(selectReqList);
      if (res.result) {
        alert("정상적으로 삭제되었습니다.");
        fetchData();
      } else {
        alert("정상적으로 삭제되지 않았습니다.");
        return;
      }
    }
  };

  const handleChange = (e) => {
    setInput({
      ...input,
      [e.target.name]: e.target.value,
    });
  };

  const uptContact = async () => {
    toggleShow();
    const param = {
      status: input.status,
      answer: input.procContents,
    };

    if (window.confirm("입력한 내용을 저장하시겠습니까?")) {
      const res = await updateContact(input.contactNo, param);
      if (res.result) {
        alert("정상적으로 저장되었습니다.");
        fetchData();
      } else {
        alert("정상적으로 저장되지 않았습니다.");
        return;
      }
    }
  };

  return (
    <div id="pageid31">
      {/* Bot 추가 Modal 시작 */}
      <Modal
        show={isShow}
        // aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">상세 보기</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>고객사명</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              readOnly
              type="text"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="companyName"
              maxLength="25"
              value={input.companyName || ""}
              style={{
                backgroundColor: "lightgrey",
                borderCcolor: "lightgrey",
              }}
            />
          </div>
          <p>부서</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              readOnly
              type="text"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="department"
              maxLength="25"
              value={input.department || ""}
              style={{
                backgroundColor: "lightgrey",
                borderCcolor: "lightgrey",
              }}
            />
          </div>
          <p>휴대폰 번호</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              readOnly
              type="text"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="phone"
              maxLength="15"
              value={input.phone || ""}
              style={{
                backgroundColor: "lightgrey",
                borderCcolor: "lightgrey",
              }}
            />
          </div>
          <p>이메일 주소</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              readOnly
              type="text"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="email"
              maxLength="30"
              value={input.email || ""}
              style={{
                backgroundColor: "lightgrey",
                borderCcolor: "lightgrey",
              }}
            />
          </div>
          <p>회원 분류</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              readOnly
              type="text"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="userType"
              maxLength="30"
              value={input.userType || ""}
              style={{
                backgroundColor: "lightgrey",
                borderCcolor: "lightgrey",
              }}
            />
          </div>
          <p>문의 분류</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              readOnly
              type="text"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="reqType"
              maxLength="30"
              value={input.reqType || ""}
              style={{
                backgroundColor: "lightgrey",
                borderCcolor: "lightgrey",
              }}
            />
          </div>
          <p>라이선스</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              readOnly
              type="text"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="licenseNumber"
              maxLength="50"
              value={input.licenseNumber || ""}
              style={{
                backgroundColor: "lightgrey",
                borderCcolor: "lightgrey",
              }}
            />
          </div>
          <p>상태</p>
          <div className="form-group fv-plugins-icon-container">
            <select
              className="form-control form-control-lg form-control-solid"
              name="status"
              onChange={(e) => handleChange(e)}
              value={input.status}
            >
              <option value="contact">문의</option>
              <option value="review">처리중</option>
              <option value="finish">완료</option>
            </select>
          </div>
          <p>문의 내용</p>
          <div className="form-group fv-plugins-icon-container">
            <textarea
              className="modal-textarea"
              readOnly
              name="contents"
              value={input.contents}
              onChange={(e) => handleChange(e)}
              style={{
                backgroundColor: "lightgrey",
                borderCcolor: "lightgrey",
              }}
            ></textarea>
          </div>
          <p>처리 내용</p>
          <div className="form-group fv-plugins-icon-container">
            <textarea
              className="modal-textarea"
              name="procContents"
              value={input.procContents || ""}
              onChange={(e) => handleChange(e)}
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={() => {
                toggleShow();
              }}
              className="btn btn-light btn-elevate"
            >
              취소
            </button>
            <> </>
            <button
              type="button"
              onClick={uptContact}
              className="btn btn-primary btn-elevate"
              // disabled={
              // 	!emailId || !password || !confirmPass || !choiceLicenseName
              // }
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* Bot 추가 Modal 끝 */}

      <div style={{ marginTop: 30 }}>
        <h3 className="card-label font-weight-bolder text-dark d-flex align-items-center mb-0">
          라이선스 문의 관리
        </h3>
      </div>
      <div className="top-row gutter-b d-flex align-items-center flex-column">
        <div
          className="d-flex align-items-center justify-content-end w-100"
          style={{ marginTop: 50 }}
        >
          <div>
            <Button
              className={`btn btn-danger font-weight-bolder font-size-sm mr-2`}
              // style={{ border: "solid 1px #D1D3E0" }}
              onClick={delReqHistory}
            >
              삭제
            </Button>
          </div>
        </div>
      </div>

      <div className="gutter-b">
        <div className="table-responsive">
          <MUIDataTable
            // title={"Bot 관리"}
            data={licenseReqList}
            columns={columns}
            options={options}
          />
        </div>
      </div>
    </div>
  );
}
export default LicenseReqMng;
